import React from "react";
import InputComp from "../InputComp/InputComp";
import { useRef } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const RegisterComp = () => {
  const [data, setDatabase] = useState({
    name: "",
    surname: "",
    email: "",
    number: "",
    password: "",


  });
  const navigate = useNavigate(); // Initialize useNavigate

  const handleInput = (e) =>
    setDatabase({ ...data, [e.target.name]: e.target.value });

  const firstnameRef = useRef(null);

  const handleRegister = (e) => {
    e.preventDefault();

    // Store user data in localStorage
    localStorage.setItem("userEmail", data.email);
    localStorage.setItem("userPassword", data.password); // Consider hashing this for production use

    alert("Registration successful! You can now log in.");
    // Optionally, clear the form
    setDatabase({ email: "", password: "" });
    navigate("/dashboard"); // Navigate to the dashboard

  };
  const loginbtn = (e) => {
    navigate("/login"); 

  }
  return (
    <div className="login-comp">
      <div className="center">
        <InputComp
          label="Name"
          inputHandler={handleInput}
          placeholder="John"
          value={data.name}
          name="name"
          type="text"
        />
                <InputComp
          label="Surname"
          inputHandler={handleInput}
          placeholder="Doe"
          value={data.surname}
          name="surname"
          type="text"
        />
                        <InputComp
          label="Email"
          inputHandler={handleInput}
          placeholder="john@doe.com"
          value={data.email}
          name="email"
          type="text"
        />
         <InputComp
          label="Phone Number"
          inputHandler={handleInput}
          placeholder="+389 77645001"
          value={data.number}
          name="number"
          type="text"
        />
        <InputComp
          label="Password"
          inputHandler={handleInput}
          placeholder="Password"
          name="password"
          value={data.password}
          type="password"
        />
        <div className="buttons">
          <button onClick={loginbtn} className="mui-button">Login</button>
          <button onClick={handleRegister} className="mui-button">Register</button>
        </div>
      </div>
    </div>
  );
};

export default RegisterComp;
